import { Component, Input } from '@angular/core';
import { FlexAlignment, SimplePriceInfoSize } from '@com-delta-idp/mnx-ui-kit';
import { Price, Pricing } from '../../pages/fast-action-banner-page/models';

@Component({
  selector: 'idp-simple-price-info',
  templateUrl: './simple-price-info.component.html',
  styleUrls: ['./simple-price-info.component.scss']
})
export class SimplePriceInfoComponent implements Pricing {
  @Input() multiUnit = false;
  @Input() cash: Price | undefined = {} as Price;
  @Input() miles: Price | undefined = {} as Price;
  @Input() displayMilesBelowCash = false;
  @Input() size: SimplePriceInfoSize = 'base';
  @Input() flexAlign: FlexAlignment = 'flex-end';
}
